import { render, staticRenderFns } from "./bathroom.vue?vue&type=template&id=2b789166&"
import script from "./bathroom.vue?vue&type=script&lang=js&"
export * from "./bathroom.vue?vue&type=script&lang=js&"
import style0 from "./bathroom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports